
import { IMediated, IRunnable, IQuery, ITypedQuery, mediated_data_types } from 'core-ts-types';
import { ORM } from './../engine/orm';
import * as _4 from 'lodash';

const NO_RETURN_VALUE = '__no-promise-value__';
export type TCommandImplementation<P> = (...properties: any[]) => Promise<P>;

/**
 * register a command, returning a new function which executes the command and handles updating all registered elements in the ORM
 * @param action the action definition of the command
 * @param sources optional sources which should be considered to have updated inside the Command (this is automatic)
 */
export const registerCommand = <P, F extends TCommandImplementation<P>>(action: F, ...sources: (IMediated | mediated_data_types)[]): F => {
  return function (...args: any[]): Promise<P> {
    return action(...args).then((_rtn: any) => {
      const queries = ORM.run(...sources);
      return (_rtn === NO_RETURN_VALUE)
        ? queries as any
        : _rtn;
    });
  } as F;
};

/**
 * abstracts creating a Promise and failing the Promise if Error's are returned
 * @param resolveResult the value or function providing a value to return to the Promise
 */
export const safeResolve = <P>(resolveResult: (() => P | undefined | null) | P | undefined | null): Promise<P> => {
  return new Promise<P>((resolve, reject) => {
    const value = (typeof resolveResult === 'function')
      ? _4.call(resolveResult)
      : resolveResult;

    if (value instanceof Error) {
      reject(value);
    }
    else {
      resolve(value as P);
    }
  });
};

/**
 * If a Command does not return a value or you want a Command to return all Queries updated, then invoke this method on return of your _action_ to the Command
 */
export const requestQueries = (): (IQuery | ITypedQuery<any>)[] => {
  return NO_RETURN_VALUE as any;
};



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-orm/dist/types/command.ts